import axios from 'axios';

export interface EmpresaVencimientoResumen {
  indicador: string;
  cantidad: number;
  porcentaje: number;
  color: string;
}

export const EMPRESA_VENCIMIENTO_INDICADORES = [
  { id: 'En Vigencia', label: 'En Vigencia', color: 'green' },
  { id: 'Proximo a Vencer', label: 'Próximo a vencer', color: 'orange' },
  { id: 'Sin Vencimiento', label: 'Sin vencimiento', color: 'gray' },
  { id: 'Vencido', label: 'Vencido', color: 'red' },
] as const;

export const EMPRESA_VENCIMIENTO_INDICADOR_PROXIMO =
  EMPRESA_VENCIMIENTO_INDICADORES[1].id;

export const EMPRESA_VENCIMIENTO_INDICADOR_VENCIDO =
  EMPRESA_VENCIMIENTO_INDICADORES[3].id;

export const EMPRESA_VENCIMIENTO_COLORS: Record<
  (typeof EMPRESA_VENCIMIENTO_INDICADORES)[number]['id'],
  string
> = {
  'En Vigencia': '#22c55e',
  'Proximo a Vencer': '#f97316',
  'Sin Vencimiento': '#94a3b8',
  'Vencido': '#ef4444',
};

export const INDICADOR_TO_VENCIMIENTO_ESTADO: Record<
  (typeof EMPRESA_VENCIMIENTO_INDICADORES)[number]['id'],
  string
> = {
  'En Vigencia': 'EN_VIGENCIA',
  'Proximo a Vencer': 'PROXIMO_A_VENCER',
  'Sin Vencimiento': 'SIN_VENCIMIENTO',
  'Vencido': 'VENCIDO',
};

export type EmpresaVencimientoFilterParam =
  | 'vencimientoSellosEstado'
  | 'vencimientoFielEstado';

export function cantidadEmpresaVencimientoPorIndicador(
  rows: EmpresaVencimientoResumen[],
  indicador: string,
): number {
  const row = rows.find(r => String(r.indicador).trim() === indicador);
  return Number(row?.cantidad) || 0;
}

export function vencimientoEstadoFromIndicador(indicador: string): string | null {
  return (
    INDICADOR_TO_VENCIMIENTO_ESTADO[
      indicador as (typeof EMPRESA_VENCIMIENTO_INDICADORES)[number]['id']
    ] ?? null
  );
}

export function appendEmpresaVencimientoFilterParams(
  base: URLSearchParams,
  param: EmpresaVencimientoFilterParam,
  indicador: string,
): URLSearchParams | null {
  const estado = vencimientoEstadoFromIndicador(indicador);
  if (!estado) return null;
  const params = new URLSearchParams(base);
  params.set('page', '1');
  params.set(param, estado);
  return params;
}

export function buildEmpresasVencimientoFilterUrl(
  param: EmpresaVencimientoFilterParam,
  indicador: string,
): string | null {
  const params = appendEmpresaVencimientoFilterParams(new URLSearchParams(), param, indicador);
  return params ? `/empresas?${params.toString()}` : null;
}

export async function fetchEmpresaVencimientoSellosResumen(): Promise<EmpresaVencimientoResumen[]> {
  try {
    const res = await axios.get<EmpresaVencimientoResumen[]>(
      `api/empresas/indicadores-vencimiento-sellos/resumen?cacheBuster=${Date.now()}`,
    );
    return Array.isArray(res.data) ? res.data : [];
  } catch {
    return [];
  }
}

export async function fetchEmpresaVencimientoFielResumen(): Promise<EmpresaVencimientoResumen[]> {
  try {
    const res = await axios.get<EmpresaVencimientoResumen[]>(
      `api/empresas/indicadores-vencimiento-fiel/resumen?cacheBuster=${Date.now()}`,
    );
    return Array.isArray(res.data) ? res.data : [];
  } catch {
    return [];
  }
}
